/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import SeQuenXLogo from "../assets/svg/SeQuenXLogoWhite.svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const quickLinks = t("footer.quickLinks", { returnObjects: true });
  const policies = t("footer.policies", { returnObjects: true });

  return (
    <footer className="bg-gradient-to-b from-[#0B1B3B] via-[#122B5A] to-[#1A3D7A] text-white">
      <div className="container mx-auto px-6 py-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
            <img src={SeQuenXLogo} alt="logo" className="w-32 mb-5" />

            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              {t("footer.description")}
            </p>

            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/sequenx-b.v./"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white transition-all duration-300"
              >
                <FaLinkedin size={18} />
              </a>

              <a
                href="mailto:info@sequenx.com"
                className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white transition-all duration-300"
              >
                <MdOutlineMail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-semibold tracking-widest text-white mb-4 uppercase">
              {t("footer.quickLinksTitle")}
            </h3>

            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.link}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-xs font-semibold tracking-widest text-white mb-4 uppercase">
              {t("footer.policiesTitle")}
            </h3>

            <ul className="space-y-3">
              {policies.map((policy, index) => (
                <li key={index}>
                  <a
                    href={policy.link}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {policy.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="my-4 border-t border-white/10" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <p className="text-gray-300 text-xs">
            © 2016 - {new Date().getFullYear()} {t("footer.copyright")}
          </p>

          <p className="text-gray-300 text-xs">{t("footer.officeHours")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
